// Workplace Communication Research (2026-02) — the 6 existing,
// already-published Tally forms. MUST mirror `backend/research_tracking_dispatch.py`'s
// `FORM_MAP` exactly (the backend independently re-validates this
// same mapping and rejects any mismatch — this file is a convenience
// for the UI, never the source of truth on its own).
export const RESEARCH_ID = "workplace_communication";

export const TALLY_FORM_IDS = {
  en: { leaders: "EqzNN4", hr: "GevQQZ" },
  el: { leaders: "PRjGGV", hr: "o96kkP" },
  "pt-BR": { leaders: "rDykkN", hr: "OQ1ooR" },
};

export const TALLY_EMBED_ORIGIN = "https://tally.so";

export const tallyEmbedSrc = (formId) =>
  `https://tally.so/r/${formId}?transparentBackground=1&formEventsForwarding=1`;

export const researchCanonicalName = (language, audience) => `${RESEARCH_ID}_${language}_${audience}`;
